import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

export function googleDriveLinkValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) {
            return null
        }
        const googleDriveRegex =
            /^https?:\/\/(?:drive\.google\.com\/(?:file\/d\/|open\?id=)|docs\.google\.com\/(?:document|spreadsheets|presentation|forms|drawings|jamboard)\/d\/|sites\.google\.com\/(?:site|view)\/)([a-zA-Z0-9_-]+)/

        if (!googleDriveRegex.test(control.value)) {
            return { invalidGoogleDriveLink: { message: 'Lien google drive invalide' } }
        }

        return null
    }
}
